import { render, staticRenderFns } from "./stateless.vue?vue&type=template&id=08224103&scoped=true&"
import script from "./stateless.vue?vue&type=script&lang=js&"
export * from "./stateless.vue?vue&type=script&lang=js&"
import style0 from "./stateless.vue?vue&type=style&index=0&id=08224103&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08224103",
  null
  
)

export default component.exports